import React from 'react';

export const AccordionContext = React.createContext();
export default AccordionContext;
